var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whitespace-nowrap text-base-90"},[_c('div',{staticClass:"flex items-center justify-start px-2 space-x-2 context-menu-item foo",class:{
      'hover:bg-base-10 cursor-pointer': _vm.clickable && !_vm.disabled,
      'text-xs leading-6': _vm.size === 'sm',
      'leading-9': _vm.size === 'md',
      'disabled': _vm.disabled,
      'border-b border-base-30': _vm.hasDivider,
    },on:{"click":_vm.handleItemClick}},[_vm._t("default")],2),_vm._t("detail")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }